export default [
    {
        path: '',
        name: 'pageDireksi',
        component: () => import('./page-direksi')
    }
]